<template>
  <div class="twcs-fixed twcs-inset-0 twcs-overflow-hidden twcs-z-[1001]">
    <div class="twcs-absolute twcs-inset-0 twcs-overflow-hidden">
      <Transition
        enter-active-class="twcs-ease-in-out twcs-duration-300"
        enter-from-class="twcs-opacity-0"
        enter-to-class="twcs-opacity-100"
        leave-active-class="twcs-ease-in-out twcs-duration-500"
        leave-from-class="twcs-opacity-100"
        leave-to-class="twcs-opacity-0"
      >
        <!--
          Background overlay, show/hide based on slide-over state.

          Entering: "ease-in-out duration-500"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in-out duration-500"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div v-if="modalShow" class="twcs-absolute twcs-inset-0 twcs-bg-gray-500 twcs-bg-opacity-75 twcs-transition-opacity" aria-hidden="true"></div>
      </Transition>
      <section class="twcs-absolute twcs-inset-y-0 twcs-left-0 twcs-pr-10 twcs-max-w-full twcs-flex" aria-labelledby="slide-over-heading" @keydown="onKeydownEvent">
        <Transition
          enter-active-class="twcs-transform twcs-transition twcs-ease-in-out twcs-duration-300 sm:twcs-duration-500"
          enter-from-class="twcs--translate-x-full"
          enter-to-class="twcs--translate-x-0"
          leave-active-class="twcs-transform twcs-transition twcs-ease-in-out twcs-duration-500 sm:twcs-duration-700"
          leave-from-class="twcs--translate-x-0"
          leave-to-class="twcs--translate-x-full"
        >
          <!--
            Slide-over panel, show/hide based on slide-over state.

            Entering: "transform transition ease-in-out duration-500 sm:duration-700"
              From: "translate-x-full"
              To: "translate-x-0"
            Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
              From: "translate-x-0"
              To: "translate-x-full"
          -->
          <div v-if="modalShow" class="twcs-w-screen twcs-max-w-md">
            <div class="twcs-h-full twcs-flex twcs-flex-col twcs-pt-6 twcs-pb-4 twcs-bg-white twcs-shadow-xl">
              <div class="twcs-relative">
                <div class="twcs-px-4 sm:twcs-px-6 twcs-sticky">
                  <div class="twcs-col-span-1 twcs-grid twcs-grid-cols-6 twcs-gap-2">
                    <div class="twcs-flex twcs-items-center twcs-justify-start">

                    </div>
                    <div class="twcs-col-span-4 twcs-justify-center">
                      <h2 id="slide-over-heading" class="twcs-m-0 twcs-text-center twcs-text-lg twcs-font-medium twcs-text-gray-900">
                        Categories
                      </h2>
                    </div>
                    <div class="twcs-col-span-1 twcs-flex twcs-items-center twcs-justify-end">
                      <button
                        @click="onClose()"
                        ref="closeButtonRef"
                        class="twcs-bg-white twcs-rounded-md twcs-text-gray-400 hover:twcs-text-gray-500 focus:twcs-outline-none focus-visible:twcs-ring-2 focus-visible:twcs-ring-offset-2 focus-visible:twcs-ring-kctcs-gold-200"
                        id="close-button"
                      >
                        <span class="twcs-sr-only">Close panel</span>
                        <!-- Heroicon name: outline/x -->
                        <svg class="twcs-h-6 twcs-w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="twcs-mt-6 twcs-relative twcs-flex-1 twcs-overflow-y-auto">
                <Transition
                  enter-active-class="twcs-ease-in-out twcs-duration-200"
                  enter-from-class="twcs-opacity-0"
                  enter-to-class="twcs-opacity-100"
                  leave-active-class="twcs-ease-in-out twcs-duration-200"
                  leave-from-class="twcs-opacity-100"
                  leave-to-class="twcs-opacity-0"
                  mode="out-in"
                >
                  <nav v-if="!filterSearchStore.searchData.navLoading" class="twcs-space-y-1 twcs-p-1">
                    <!-- Current: "bg-gray-50 text-kctcs-navy-700 hover:text-kctcs-navy-700 hover:tbg-white", Default: "text-gray-900 hover:text-gray-900 hover:bg-gray-50" -->
                    <!-- Current: "text-kctcs-navy-500 group-hover:text-kctcs-navy-500", Default: "text-gray-400 group-hover:text-gray-500" -->
                    <a
                      v-for="category in filterSearchStore.searchData.categories"
                      tabindex="-1"
                      :key="category.name"
                      @click.prevent="onCategoryNavClick(category)"
                      :class="[category.name === filterSearchStore.searchData.currentNav.name
                      ? 'twcs-bg-gray-200 twcs-text-gray-900'
                      : 'twcs-text-gray-600 hover:twcs-bg-gray-50 hover:twcs-text-gray-900 ',
                      'twcs-group twcs-flex twcs-items-center twcs-px-2 twcs-py-2 twcs-text-base twcs-font-medium twcs-rounded-md']"
                      href="#"
                      :id="category.name.replace(/\s+/g, '-').toLowerCase()+'-nav-modal'"
                    >
                      <span class="twcs-truncate">
                        {{ category.name }}
                      </span>

                      <span
                        class="twcs-bg-gray-100 twcs-ml-auto twcs-inline-block twcs-py-0.5 twcs-px-3 twcs-text-base twcs-font-medium twcs-rounded-full"
                        :class="{ 'group-hover:twcs-bg-gray-100 twcs-bg-gray-200': category.name !== filterSearchStore.searchData.currentNav.name}"
                      >
                        {{ category.count }}
                      </span>
                    </a>
                  </nav>
                  <div v-else class="twcs-p-7 twcs-bg-white">
                    <div class="twcs-h-full">
                      <div class="twcs-loader-animation twcs-relative twcs-overflow-hidden twcs-bg-gray-150" style="height: 13.5rem;">
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-twcs-top-2 twcs-twcs-bg-white twcs-h-4"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-6 twcs-bg-white twcs-h-2"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-8 twcs-bg-white twcs-h-4"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-top-12 twcs-bg-white twcs-h-2"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-top-14 twcs-bg-white twcs-h-6"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 5.5rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 6.5rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 7rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 8rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-6" style="top: 8.5rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 10.5rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 11.5rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-0 twcs-bg-white twcs-h-4" style="top: 12rem;"></div>
                        <div class="twcs-absolute twcs-right-0 twcs-left-96 md:twcs-left-3/4 twcs-bg-white twcs-h-2" style="top: 13rem;"></div>
                      </div>
                    </div>
                  </div>
                </Transition>
              </div>
            </div>
          </div>
        </Transition>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Bugsnag from '@bugsnag/js';
import { useFilterSearchStore } from '@/stores/filter-search.js';
import { scrollToCategoryHeading } from '@/helpers/scroll-to-category.js';

defineProps({
	modalOpen: {
		type: Boolean,
		required: true,
	},
	modalShow: {
		type: Boolean,
		required: true,
	},
});

let emit = defineEmits(['modalCloseOnClick']);

let filterSearchStore = useFilterSearchStore();
let buttonRef = document.activeElement;
let currentFocusedRef = ref(0);

let focusables = computed(() => {
	let returnArr = filterSearchStore.searchData.categories.map((category) => category.name.replace(/\s+/g, '-').toLowerCase()+'-nav-modal');
	returnArr.push('close-button');
	return returnArr;
});
let closeButtonRef = ref(null);

function onClose() {
	buttonRef.focus();
	emit('modalCloseOnClick', false);
}

async function onCategoryNavClick(category) {
	onClose();
	try {
		let completed = await filterSearchStore.navigateCategory(category);
		if (!completed) {
			return;
		}
		await scrollToCategoryHeading(category.name);
	} catch (err) {
		Bugsnag.notify(err);
	}
}

function onKeydownEvent(event) {
	if(event.key === 'ArrowDown' || event.key === 'ArrowUp') {
		event.preventDefault();
	}

	if(event.key === 'Escape') {
		onClose();
		event.preventDefault();
	}

	if(event.key !== 'Tab') {
		return;
	}
	if(event.shiftKey) {
		// shift+tab
		currentFocusedRef.value = currentFocusedRef.value === 0 ? focusables.value.length - 1 : currentFocusedRef.value - 1;
		document.getElementById(focusables.value[currentFocusedRef.value]).focus();
		event.preventDefault();
	} else {
		// just tab
		currentFocusedRef.value = currentFocusedRef.value === focusables.value.length - 1 ? 0 : currentFocusedRef.value + 1;
		document.getElementById(focusables.value[currentFocusedRef.value]).focus();
		event.preventDefault();
	}
}

onMounted(() => {
	setTimeout(() => {
		currentFocusedRef.value = 0;
		document.getElementById(focusables.value[currentFocusedRef.value]).focus();
	}, 500);
});
</script>
